<app-roster-roster-link [termCode]="termCode" [crn]="crn"></app-roster-roster-link>
What content? Or when user click on the <mat-icon>help</mat-icon> icon take the user to another site?
